import { useCallback } from 'react'
import { useFileFormatValidator } from 'hooks/useFileFormatValidator'
import { useAlertPopupsContext } from 'context/AlertPopups'
import { IMyFilesMediaItem } from 'types/media'
import { validateImagesForAIVideo } from '../utils'
import { useSelector } from 'react-redux'
import { aiVideoSelectors } from 'store/features/aiVideo/selectors'

export const useAiVideoFileValidator = () => {
  const supportedImageMimeTypes = useSelector(
    aiVideoSelectors.supportedImageMimeTypes
  )
  const validateFiles = useFileFormatValidator(
    'AIVideoImage',
    supportedImageMimeTypes
  )

  const createUploadHandler = useCallback(
    (uploadFn: (files: File[]) => void) => async (files: File[] | FileList) => {
      if (!files || !files.length) return
      const valid = validateFiles(Array.from(files))
      if (!valid.length) return
      uploadFn(valid)
    },
    [validateFiles]
  )

  return { createUploadHandler, validateFiles }
}

export const useMediaLibValidator = () => {
  const supportedImageMimeTypes = useSelector(
    aiVideoSelectors.supportedImageMimeTypes
  )
  const { setAlertPopupsData } = useAlertPopupsContext()

  const validateMediaLibFiles = useCallback(
    (files: IMyFilesMediaItem[]): IMyFilesMediaItem[] | null => {
      if (!files.length) return null
      const valid = validateImagesForAIVideo(files, supportedImageMimeTypes)
      if (!valid.length || valid.length !== files.length) {
        setAlertPopupsData({ errorPopup: { type: 'unsupportedFileFormat' } })
        return null
      }
      return valid
    },
    [setAlertPopupsData, supportedImageMimeTypes]
  )

  return { validateMediaLibFiles }
}
